import { loginApi, userApi } from '@/apis';
import { getStorage, setStorage, removeStorage } from '@/utils/util';
import {
	USER_INFO,
	USER_ID,
	TOKEN,
	UUID,
	EXPIRED_TIME,
	LOGIN_TIME_STAMP,
} from '@/constants/index';
import router from '@/router';

export default {
	namespaced: true,

	state: {
		token: getStorage(TOKEN),
		userInfo: getStorage(USER_INFO) || null,
		userId: getStorage(USER_ID) || '',
	},

	mutations: {
		setToken(state, token) {
			state.token = token;
		},

		setUserInfo(state, userInfo) {
			state.userInfo = userInfo;
			setStorage(USER_INFO, userInfo);
		},

		clear(state) {
			state.userInfo = null;
			state.token = '';
			removeStorage(TOKEN);
			removeStorage(USER_INFO);
			removeStorage(USER_ID);
			removeStorage(EXPIRED_TIME);
			removeStorage(LOGIN_TIME_STAMP);
		},
	},
	actions: {
		async login({ commit }, params) {
			try {
				const res = await loginApi.account_in(params);
				commit('setToken', res['access_token']);
				commit('setUserInfo', {
					name: res.nick_name,
					phone: res.phone,
				});
				setStorage(TOKEN, res['access_token']);
				setStorage(EXPIRED_TIME, res['expired_time']);
				setStorage(LOGIN_TIME_STAMP, Date.now());
				res['user_id'] && setStorage(USER_ID, res['user_id']);
				return true;
			} catch (err) {
				// 登录失败
				return false;
			}
		},

		async logout({ commit }) {
			await loginApi.signout();
			const uuid = getStorage(UUID);
			commit('clear');
			commit('device/setCurrentDeviceId', '', { root: true });
			setStorage(UUID, uuid);
			router.push('/login?uuid=' + uuid);
		},

		async getUserInfo({ commit }) {
			try {
				const res = await userApi.shop_load_data();
				commit('setUserInfo', {
					name: res.name,
					phone: res.phone,
				});
				return res;
			} catch {
				return null;
			}
		},

		async guestIn({ commit }, params) {
			try {
				const res = await loginApi.guest_in({
					uuid: params.uuid,
				});
				commit('setToken', res['access_token']);
				commit('setUserInfo', {
					name: res.nick_name,
					phone: res.phone,
				});
				setStorage(TOKEN, res['access_token']);
				setStorage(EXPIRED_TIME, res['expired_time']);
				setStorage(LOGIN_TIME_STAMP, Date.now());
				res['user_id'] && setStorage(USER_ID, res['user_id']);
				return true;
			} catch {
				return false;
			}
		},

		async wxIn({ commit }, params) {
			try {
				const res = await loginApi.wx_in({
					uuid: params.uuid,
				});
				commit('setToken', res['access_token']);
				commit('setUserInfo', {
					name: res.nick_name,
					phone: res.phone,
				});
				setStorage(TOKEN, res['access_token']);
				setStorage(EXPIRED_TIME, res['expired_time']);
				setStorage(LOGIN_TIME_STAMP, Date.now());
				res['user_id'] && setStorage(USER_ID, res['user_id']);
				return true;
			} catch {
				return false;
			}
		},

		async enterpriseIn({ commit }, params) {
			try {
				const res = await loginApi.enterprise_in({
					uuid: params.uuid,
				});
				commit('setToken', res['access_token']);
				commit('setUserInfo', {
					name: res.nick_name,
					phone: res.phone,
				});
				setStorage(TOKEN, res['access_token']);
				setStorage(EXPIRED_TIME, res['expired_time']);
				setStorage(LOGIN_TIME_STAMP, Date.now());
				res['user_id'] && setStorage(USER_ID, res['user_id']);
				return true;
			} catch {
				return false;
			}
		},
	},
};
